import styled from '@emotion/styled';
import { Typography } from '@kc-console/common-ui';

import { useMegaMenuState } from '../../../../hooks';

import type { KeyboardEvent } from 'react';
import type { MegaMenuCategory } from '@kc-console/context';

interface Props {
  category: MegaMenuCategory;
}

const MegaMenuSidebarMenuItem = (props: Props) => {
  const { activeCategory, setActiveCategory } = useMegaMenuState();
  const { category } = props;

  const selected = category.name === activeCategory;

  const handleKeyDown = (e: KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      setActiveCategory(category.name);
    }
  };

  return (
    <StyledSidebarMenuItem
      selected={selected}
      onClick={() => setActiveCategory(category.name)}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <Typography variant={selected ? 'label/medium/md' : 'label/regular/md'}>
        {category.name}
      </Typography>
    </StyledSidebarMenuItem>
  );
};

const StyledSidebarMenuItem = styled.li<{ selected: boolean }>`
  width: 240px;
  padding: 10px 24px;
  margin-right: -1px;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#f6f7f9' : 'transparent')};
  border-right: ${({ selected }) => (selected ? '1px solid #21262C' : 'none')};

  &:hover {
    background-color: #f9fafb;
    border-right: 1px solid #121619;
    font-weight: 500;
  }

  &:active {
    background-color: #f6f7f9;
    border-right: 1px solid #121619;
    font-weight: 500;
  }

  &:focus-visible {
    outline: 2px solid #000;
    outline-offset: -2px;
    font-weight: 500;
  }
`;

export default MegaMenuSidebarMenuItem;
